import { actions } from './action'

const initialState = {
  candidateData: {
    candidateList: [],
    totalCount: 0,
  },
  pagination: {
    skip: 0,
    limit: 10,
  },
  // On Board uses one Pending queue rather than interview rounds.
  status: 0,
  step: 0,
  filterSkill: null,
  filterSkillLevel: null,
  grade: null,
  feedbackList: [],
  skills: [],
}
const candidateState = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_CANDIDATE_LIST:
      return {
        ...state,
        candidateData: {
          candidateList: action.payload.candidateList,
          totalCount: action.payload.totalCount,
        },
      }

    case actions.HANDLE_PAGINATION:
      return {
        ...state,
        pagination: action.payload,
      }
    case actions.HANDLE_STATUS:
      return {
        ...state,
        status: action.payload,
      }
    case actions.HANDLE_ROUND_STEP:
      return {
        ...state,
        step: action.payload,
      }
    case actions.GET_FEEDBACK:
      return {
        ...state,
        feedbackList: action.payload,
      }
    case actions.GET_SKILLS:
      return {
        ...state,
        skills: action.payload,
      }
    case actions.HANDLE_FILTER_SKILL:
      return {
        ...state,
        filterSkill: action.payload,
      }
    case actions.HANDLE_FILTER_SKILL_LEVEL:
      return {
        ...state,
        filterSkillLevel: action.payload,
      }
    case actions.HANDLE_GRADE:
      return {
        ...state,
        grade: action.payload,
      }
    default:
      return state
  }
}
export default candidateState
